export const COLOR_BLACK = "#000000";
export const COLOR_WHITE = "#FFFFFF";

export const COLOR_GREEN = "#0C9";
export const COLOR_DARK = "#2B2F32";
export const COLOR_DARK_GREY = "#5E6366";
export const COLOR_GREY = "#ABAFB1";
export const COLOR_RED = "#FF4D4F";
export const COLOR_GREY_1 = "#E3E6F1";
